import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { AppliedFilter } from './applied-filter';
import { ClearButton } from './clear-button';
import * as S from './styles';
import type { TranslateFunc } from 'src/components/translate';

type AppliedFiltersProps<T> = {
  filters: T[];
  filterFormatFn: (data: { filter: T; t: TranslateFunc }) => {
    title?: string;
    value: string;
    key: string;
  };
  onClearAll: () => void;
  onClearFilter: (filter: T) => void;
};

const AppliedFilters = <T extends object>(
  props: React.PropsWithChildren<AppliedFiltersProps<T>>
) => {
  const { t } = useAppContext();

  const formattedFilters = props.filters.map(filter => ({
    filter,
    formatted: props.filterFormatFn({ filter, t }),
  }));

  if (!formattedFilters?.length) return null;

  return (
    <S.AppliedFiltersWrapper data-test="AppliedFiltersWrapper">
      <S.AppliedFilters gap={0.5}>
        <S.AppliedFiltersTitle>
          {t('filter', 'applied-filters.title')}:
        </S.AppliedFiltersTitle>
        {formattedFilters.map(({ filter, formatted }) => (
          <AppliedFilter
            key={formatted.key}
            title={formatted.title}
            value={formatted.value}
            onClick={() => props.onClearFilter(filter)}
          />
        ))}
        <ClearButton onClick={props.onClearAll} />
      </S.AppliedFilters>
    </S.AppliedFiltersWrapper>
  );
};

export { AppliedFilters };
